export const getItemResponse_v1_schema = {};
